import React, { useEffect, useRef, useState } from "react";
import SideMenu from "../sideMenu";
import MaterialTable, { MTableToolbar } from "material-table";
import { Modal } from "react-bootstrap";
import { tableIcons } from "../../../tableIcons";
import {
  Form,
  Input,
  Button,
  Dropdown,
  Menu,
  message,
  Card,
  Alert,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import CryptoJS from "crypto-js/aes";
import { makeStyles } from "@material-ui/core/styles";

import config from "../../../config";
import { useSelector } from "react-redux";
import ReactButton from "react-bootstrap/Button";
import { Spinner } from "react-bootstrap";
import { TablePagination } from "@material-ui/core";
import { EllipsisOutlined } from "@ant-design/icons";
import { event } from "jquery";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";
import CustomTable from "../../table";
import { useNavigate } from "react-router-dom";
import { postcodeValidator } from "postcode-validator";
import { useAccess } from "../../../provider/AccessProvider";
import { VENDORACCESS } from "../../../utils/constant";
import { useHotkeys } from "react-hotkeys-hook";

const useStyles = makeStyles((theme) => ({
  formInput: {
    border: "1px solid #000",
    borderRadius: 8,
  },
  formItem: {
    fontWeight: 700,
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
}));

function PatchedPagination(props) {
  const {
    ActionsComponent,
    onChangePage,
    onChangeRowsPerPage,
    ...tablePaginationProps
  } = props;

  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      // rowsPerPageOptions={["20", "50", "100", "500"]}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
}

const VendorMangagement = (props) => {
  useEffect(() => {
    function keydownHandler(event) {
      // event.preventDefault();
      event.stopImmediatePropagation();
      if (event.altKey && event.keyCode == 65) {
        //  AddVender (A)
        handleClick();
      } else if (event.altKey && event.keyCode == 84) {
        // Download tax input report (T)
        taxInputReport();
      }
    }
    document.addEventListener("keydown", keydownHandler, false);
    return () => {
      document.removeEventListener("keydown", keydownHandler, false);
    };
  }, []);

  const shopDetails = useSelector((state) => state.shopDetails);
  const classes = useStyles();
  const [show, setShow] = React.useState(false);
  const [vendorsList, setVendorsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState("add");
  const [initialValues, setInitialValues] = useState({});
  const formRef = useRef();
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const navigate = useNavigate();
  const access = useAccess(VENDORACCESS);

  const menu = (data) => {
    return (
      <Menu>
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            if (!access.viewDetails()) {
              return;
            }
            navigate({
              pathname: `/dashboard/vendor-management/vendor-details`,
              search: `?id=${data.userId}`,
            });
          }}
          key="print"
        >
          View Details
        </Menu.Item>
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            if (!access.editVendor()) {
              return;
            }
            setInitialValues(data);
            setMode("edit");
            setShow(true);
          }}
          key="view"
        >
          Edit vendor
        </Menu.Item>
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            if (!access.addBill()) {
              return;
            }
            navigate(
              {
                pathname: `/dashboard/vendor-management/add-bill`,
                search: `?id=${data.userId}`,
              },
              {
                state: {
                  data,
                },
              }
            );
          }}
          key="add-bill"
        >
          Add Bill
        </Menu.Item>
      </Menu>
    );
  };

  const handleClose = () => {
    setMode("add");
    setInitialValues({});
    setShow(false);
  };
  const handleClick = () => {
    if (!access.createVendor()) {
      return;
    }
    setMode("add");
    setInitialValues({});
    setShow(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "userName",
      width: "20%",
    },
    {
      title: "GSTIN",
      dataIndex: "vendorGSTNumber",
    },
    {
      title: "Phone Number",
      dataIndex: "userPhoneNumber",
    },
    {
      title: "Total Number of bills",
      dataIndex: "totalNumberOfBills",
    },
    {
      title: "Total Bill Value",
      field: "totalBillValue",
      render: (data) => <>{currencyFormatter(data.totalBillValue)}</>,
    },
    {
      title: "Amount paid",
      field: "amountPaid",
      render: (data) => <>{currencyFormatter(data.amountPaid)}</>,
    },
    {
      title: "Amount pending",
      field: "amountPending",
      render: (data) => <>{currencyFormatter(data.amountPending)}</>,
    },
    {
      title: "Tax credit",
      field: "taxCredit",
      render: (data) => <>{currencyFormatter(data.taxCredit)}</>,
    },
    {
      title: "Actions",
      fixed: "right",
      render: (data) => {
        return (
          <Dropdown
            getPopupContainer={(el) => el.parentNode}
            overlay={menu(data)}
            placement="right"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "1.5rem",
                transform: "rotate(90deg)",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  const editVendor = async (values) => {
    const payload = {
      vendorId: initialValues.userId,
      userName: values.userName,
      vendorBusinessName: values.vendorBusinessName,
      userAddress: values.userAddress,
      userPincode: values.userPincode,
      userPhoneNumber: `${shopDetails.country.dialCode}${values.userPhoneNumber}`,
      vendorGSTNumber: values.vendorGSTNumber,
      ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
        parentShopId: shopDetails.ownerShopId,
      }),
      action: "editVendor",
    };
    console.log("payload", payload);
    setIsLoading(true);
    var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
      method: "POST",
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    res = await res.json();
    setShow(false);
    setMode("add");
    setInitialValues({});
    if (res.code === "ERROR") {
      setIsLoading(false);
      console.log("Err", res.data);
      return alert(res.message);
    }
    vendorInitialState();
  };

  const removeCountryCode = (phoneNumber) => {
    return phoneNumber.slice(phoneNumber?.length - 10, phoneNumber?.length);
  };

  const addVendor = async (values) => {
    const userPhoneNumber = values.userPhoneNumber;
    const isExist = vendorsList.some(
      (i) =>
        removeCountryCode(userPhoneNumber) ===
        removeCountryCode(i.userPhoneNumber)
    );
    if (isExist) {
      return alert("Vendor is already existed in your list");
    }
    setIsLoading(true);
    var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
      method: "POST",
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        shopId: shopDetails.shopId,
        userName: values.userName,
        vendorBusinessName: values.vendorBusinessName,
        userAddress: values.userAddress,
        userPincode: values.userPincode,
        action: "addVendor",
        userPhoneNumber: `${shopDetails.country.dialCode}${values.userPhoneNumber}`,
        vendorGSTNumber: values.vendorGSTNumber,
        ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
          parentShopId: shopDetails.ownerShopId,
        }),
      }),
    });
    res = await res.json();
    setShow(false);
    if (res.code === "ERROR") {
      setIsLoading(false);
      console.log("Err", res.data);
      return alert(res.message);
    }
    vendorInitialState();
  };

  useEffect(() => {
    if (shopDetails.shopId) fetchVendorDetails(shopDetails.shopId);
  }, [shopDetails]);

  var fetchVendorDetails = async (shopId) => {
    var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
      method: "POST",
      headers: {
        "x-api-key": `${config.newApiKey}`,
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        shopId: shopId,
        action: "fetchVendors",
      }),
    });
    res = await res.json();
    setIsLoading(false);
    if (res.code === "ERROR") {
      console.log("Err", res.data);
      return alert(res.message);
    }
    setVendorsList(res.data);
  };

  const vendorInitialState = () => {
    fetchVendorDetails(shopDetails.shopId);
  };

  const taxInputReport = async () => {
    setLoading(true);
    try {
      var res = await fetch(`${config.newApiGateway}/vendor/vendorManagement`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          action: "getTaxInputReport",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      setLoading(false);
      if (res.code === "ERROR") {
        console.log("Err", res.data);
        return alert(res.message);
      }
      window.open(res.data);
    } catch (err) {
      setLoading(false);
      console.log("Err", err);
    }
  };
  let autoFill = false;
  const handlePhoneNumberChange = async (e) => {
    const value = e.target.value;
    if (value.length === 10) {
      const response = await fetch(
        `${config.newApiGateway}/vendor/vendorManagement`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            userPhoneNumber: `${shopDetails.country.dialCode}${value}`,
            action: "checkVendorPhoneNumber",
          }),
        }
      );
      const userData = await response.json();
      if (userData.status === "SUCCESS") {
        autoFill = true;
        formRef.current.setFieldsValue({
          ...userData.data,
          userPhoneNumber: userData.data.userPhoneNumber.slice(
            userData.data.userPhoneNumber.length - 10,
            userData.data.userPhoneNumber.length
          ),
        });
      }
    }
    if (autoFill === true && value.length < 10) {
      formRef.current.setFieldsValue({
        userName: "",
        userAddress: "",
        userPincode: "",
        vendorBusinessName: "",
        vendorGSTNumber: "",
      });
      autoFill = false;
    }
  };

  useHotkeys("alt + a", () => {
    setMode("add");
    setInitialValues({});
    setShow(true);
  });

  if (!access.vendor(false)) {
    return (
      <Alert
        style={{ marginTop: "20px", padding: "20px", textAlign: "center" }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <>
      <div>
        <Card
          bodyStyle={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
          style={{
            marginBottom: 20,
          }}
        >
          <Button id="addVendor" type="primary" onClick={handleClick}>
            Add Vendor
          </Button>
        </Card>
        <div className="cm-table">
          <CustomTable
            data={vendorsList}
            columns={columns}
            emptyContainerStyle={{
              height: "calc(100vh - 300px)",
            }}
            style={{
              minHeight: "calc(100vh - 365px)",
            }}
            loading={isLoading}
            title={"Vendors"}
          />
          {/* <MaterialTable
            isLoading={isLoading}
            columns={columns}
            title="Vendor Management"
            icons={tableIcons}
            data={vendorsList}
            options={{
              pageSize: 10,
              emptyRowsWhenPaging: true,
              pageSizeOptions: [10, 20, 50, 100, 500],
              search: false,
            }}
            components={{
              Pagination: PatchedPagination,
              Toolbar: (prop) => (
                <div>
                  <MTableToolbar {...prop} />
                  <div className="customToolBar">
                    <div className="categoryDropdown">
                      {!loading ? (
                        <ReactButton
                          variant="outline-danger"
                          onClick={taxInputReport}
                        >
                          Download tax input report
                        </ReactButton>
                      ) : (
                        <Spinner animation="border" variant="danger" />
                      )}
                    </div>
                  </div>
                </div>
              ),
            }}
            // components={{
            //   Pagination: PatchedPagination,
            // }}
          /> */}
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>{mode === "add" ? "Add" : "Edit"} Vendor</Modal.Title>
        </Modal.Header>
        {console.log("initialValues", initialValues)}
        <Modal.Body>
          <Form
            name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            ref={formRef}
            initialValues={
              mode === "edit"
                ? {
                    ...initialValues,
                    userPhoneNumber: initialValues.userPhoneNumber?.slice?.(
                      initialValues?.userPhoneNumber?.length - 10,
                      initialValues?.userPhoneNumber?.length
                    ),
                  }
                : {}
            }
            onFinish={mode === "add" ? addVendor : editVendor}
          >
            <Form.Item
              label="Vendor Phone"
              name="userPhoneNumber"
              rules={[
                {
                  required: true,
                  message: "Please input your vendor phone!",
                },
                {
                  pattern: /^[0]?[56789]\d{9}$/,
                  message: "Please enter a valid phone number!",
                },
              ]}
              className={classes.formItem}
            >
              <Input
                onChange={handlePhoneNumberChange}
                placeholder="Enter Vendor Phone"
                size="large"
                disabled={mode === "edit"}
                className={classes.formInput}
              />
            </Form.Item>
            <Form.Item
              label="Name"
              name="userName"
              className={classes.formItem}
              rules={[
                {
                  required: true,
                  message: "Please enter vendor name!",
                },
              ]}
            >
              <Input
                onWheel={(e) => e.target.blur()}
                placeholder="Enter vendor name"
                size="large"
                className={classes.formInput}
              />
            </Form.Item>
            <Form.Item
              label="Business Name"
              name="vendorBusinessName"
              className={classes.formItem}
              rules={[
                {
                  required: true,
                  message: "Please input your Business name!",
                },
              ]}
            >
              <Input
                placeholder="Enter Business Name"
                size="large"
                className={classes.formInput}
              />
            </Form.Item>
            <Form.Item
              label="Business Address"
              name="userAddress"
              className={classes.formItem}
              rules={[
                {
                  required: true,
                  message: "Please input your vendor business address!",
                },
              ]}
            >
              <TextArea
                className={classes.formInput}
                placeholder="Enter Business Address"
              />
            </Form.Item>
            <Form.Item
              label="Business Pincode"
              name="userPincode"
              className={classes.formItem}
              rules={[
                {
                  required: true,
                  message: "Please vendor pincode!",
                },
                {
                  validator: async (_, value) => {
                    const validate = postcodeValidator(
                      value,
                      country.CountryCode
                    );
                    if (!validate) {
                      return Promise.reject(
                        new Error("Please Enter valid Pincode")
                      );
                    }
                  },
                },
              ]}
            >
              <Input
                className={classes.formInput}
                placeholder="Enter Pincode"
              />
            </Form.Item>
            <Form.Item
              label="GSTIN"
              name="vendorGSTNumber"
              className={classes.formItem}
              rules={[
                {
                  required: true,
                  message: "Please input your vendor GST Number!",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter GSTIN"
                className={classes.formInput}
              />
            </Form.Item>
            <Button
              type="primary"
              size="large"
              loading={isLoading}
              disabled={isLoading}
              style={{
                borderRadius: "8px",
                backgroundColor: "#EF4667",
                color: "#fff",
              }}
              htmlType="submit"
            >
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VendorMangagement;
